import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
import { ManagePreset } from '@manage/hes-design-system';

import App from './App.vue';
import router from './router';

const app = createApp(App);

const hesPrimeVueTheme = definePreset(Aura, ManagePreset);

app.use(createPinia());
app.use(router);
app.use(ToastService);
app.use(PrimeVue, {
  theme: {
    preset: hesPrimeVueTheme,
    options: {
      prefix: 'p',
      darkModeSelector: false,
      cssLayer: false,
    },
  },
});

app.mount('#app');
